import React from "react";
import styled from "styled-components";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import Level1Table from "./Level1Table";
import LevelGenerator from "./LevelGenerator";
import DeleteProperty from "../../../Dialog/contentUnit/ProductProperty/DeleteProperty";
import UpdateProperty from "../../../Dialog/contentUnit/ProductProperty/EditProperty";
import { useRecoilState } from "recoil";
import { ContentUnitModal } from "../../../../shared/content-unit";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

function LevelFirst() {
  const [modualsContent, setModuals] = useRecoilState(ContentUnitModal);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="ویژگی های محصول"
        num3="سطح اول"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/productProperty"
      />
      <LevelFirstStyle>
        {modualsContent.deleteProperty.isShow && (
          <DeleteProperty
            show={modualsContent.deleteProperty.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                deleteProperty: {
                  ...modualsContent.deleteProperty,
                  isShow: false,
                },
              })
            }
          />
        )}
        {modualsContent.updateProperty.isShow && (
          <UpdateProperty
            show={modualsContent.updateProperty.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                updateProperty: {
                  ...modualsContent.updateProperty,
                  isShow: false,
                },
              })
            }
          />
        )}
        <Toggle title={"افزودن  ویژگی به سطح اول"}>
          <LevelGenerator />
        </Toggle>
        <Level1Table />
      </LevelFirstStyle>
    </>
  );
}

const LevelFirstStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export default LevelFirst;
